// @ts-ignore
import Filter from "bad-words";
import profanityWords from "./profanityWords.json";
let filter = new Filter();
// @ts-ignore
filter.addWords(...profanityWords);
export { filter };
